// extracted by mini-css-extract-plugin
export var active = "_ix-2";
export var recordingDot = "_ix-1";
export var recordingIndicator = "_ix-0";